export function numberValue(value?: string): number | undefined {
  if (value === undefined) return undefined;
  const result = Number(value);
  return Number.isFinite(result) ? result : undefined;
}

export function formatNumber(value?: string, maximumFractionDigits = 4): string {
  const numeric = numberValue(value);
  if (numeric === undefined) return "—";
  return new Intl.NumberFormat("ru-RU", {
    maximumFractionDigits,
    minimumFractionDigits: 0,
  }).format(numeric);
}

export function formatMoney(value?: string, currency?: string): string {
  const numeric = numberValue(value);
  if (numeric === undefined) return "—";
  if (!currency) return formatNumber(value);
  const normalizedCurrency = currency.toUpperCase();
  try {
    return new Intl.NumberFormat("ru-RU", {
      currency: normalizedCurrency,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: Math.abs(numeric) < 10 ? 4 : 2,
      style: "currency",
    }).format(numeric);
  } catch {
    return `${formatNumber(value)} ${normalizedCurrency}`;
  }
}

export function currencySymbol(currency = "RUB"): string {
  try {
    return new Intl.NumberFormat("ru-RU", {
      currency: currency.toUpperCase(),
      currencyDisplay: "narrowSymbol",
      style: "currency",
    }).formatToParts(0).find((part) => part.type === "currency")?.value ?? currency.toUpperCase();
  } catch {
    return currency.toUpperCase();
  }
}

export function formatPercent(value?: number): string {
  if (value === undefined || !Number.isFinite(value)) return "—";
  return `${value > 0 ? "+" : ""}${new Intl.NumberFormat("ru-RU", {
    maximumFractionDigits: 2,
  }).format(value)}%`;
}

export function changeClass(value?: number): string {
  if (!value) return "muted";
  return value > 0 ? "positive" : "negative";
}

export function enumLabel(value: string): string {
  return value
    .replace(/^(ORDER_|EXECUTION_REPORT_|OPERATION_)/, "")
    .replace(/^(DIRECTION_|TYPE_|STATUS_|STATE_)/, "")
    .replaceAll("_", " ")
    .toLowerCase();
}

export function formatDateTime(value?: string): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
  }).format(date);
}

export function operationDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Без даты";
  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}
